import { render, staticRenderFns } from "./email-message-list.vue?vue&type=template&id=75f7c01f"
import script from "./email-message-list.vue?vue&type=script&lang=js"
export * from "./email-message-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75f7c01f')) {
      api.createRecord('75f7c01f', component.options)
    } else {
      api.reload('75f7c01f', component.options)
    }
    module.hot.accept("./email-message-list.vue?vue&type=template&id=75f7c01f", function () {
      api.rerender('75f7c01f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/send-list/list/common-bulk-message-list/email-message-list.vue"
export default component.exports